import React, { useState, useMemo, useEffect } from "react";
import { FaSearch, FaChevronDown, FaFilter } from "react-icons/fa";

const ALL_STATES = [
  // North Central
  {
    id: 1,
    name: "Abuja (FCT)",
    zone: "North Central",
    target: 450000,
    registered: 382500,
    last30Days: "+18,200",
    registrars: 920,
    facilitySplit: "70% / 30%",
  },
  {
    id: 2,
    name: "Benue",
    zone: "North Central",
    target: 520000,
    registered: 390000,
    last30Days: "+24,500",
    registrars: 842,
    facilitySplit: "65% / 35%",
  },
  {
    id: 3,
    name: "Kogi",
    zone: "North Central",
    target: 480000,
    registered: 105600,
    last30Days: "+8,400",
    registrars: 560,
    facilitySplit: "55% / 45%",
  },
  {
    id: 4,
    name: "Kwara",
    zone: "North Central",
    target: 420000,
    registered: 193200,
    last30Days: "+12,800",
    registrars: 680,
    facilitySplit: "60% / 40%",
  },
  {
    id: 5,
    name: "Nasarawa",
    zone: "North Central",
    target: 380000,
    registered: 285000,
    last30Days: "+16,500",
    registrars: 740,
    facilitySplit: "68% / 32%",
  },
  {
    id: 6,
    name: "Niger",
    zone: "North Central",
    target: 550000,
    registered: 192500,
    last30Days: "+10,200",
    registrars: 620,
    facilitySplit: "58% / 42%",
  },
  {
    id: 7,
    name: "Plateau",
    zone: "North Central",
    target: 490000,
    registered: 318500,
    last30Days: "+20,100",
    registrars: 780,
    facilitySplit: "72% / 28%",
  },
  // North East
  {
    id: 8,
    name: "Adamawa",
    zone: "North East",
    target: 300000,
    registered: 135000,
    last30Days: "+42,100",
    registrars: 1205,
    facilitySplit: "82% / 18%",
  },
  {
    id: 9,
    name: "Bauchi",
    zone: "North East",
    target: 800000,
    registered: 656000,
    last30Days: "+42,100",
    registrars: 1205,
    facilitySplit: "82% / 18%",
  },
  {
    id: 10,
    name: "Borno",
    zone: "North East",
    target: 750000,
    registered: 607500,
    last30Days: "+38,200",
    registrars: 1050,
    facilitySplit: "78% / 22%",
  },
  {
    id: 11,
    name: "Gombe",
    zone: "North East",
    target: 380000,
    registered: 167200,
    last30Days: "+9,800",
    registrars: 680,
    facilitySplit: "62% / 38%",
  },
  {
    id: 12,
    name: "Taraba",
    zone: "North East",
    target: 420000,
    registered: 84000,
    last30Days: "+5,200",
    registrars: 520,
    facilitySplit: "54% / 46%",
  },
  {
    id: 13,
    name: "Yobe",
    zone: "North East",
    target: 350000,
    registered: 63000,
    last30Days: "+3,800",
    registrars: 480,
    facilitySplit: "50% / 50%",
  },
  // North West
  {
    id: 14,
    name: "Jigawa",
    zone: "North West",
    target: 580000,
    registered: 464000,
    last30Days: "+28,600",
    registrars: 960,
    facilitySplit: "75% / 25%",
  },
  {
    id: 15,
    name: "Kaduna",
    zone: "North West",
    target: 700000,
    registered: 532000,
    last30Days: "+34,500",
    registrars: 1120,
    facilitySplit: "80% / 20%",
  },
  {
    id: 16,
    name: "Kano",
    zone: "North West",
    target: 900000,
    registered: 693000,
    last30Days: "+45,200",
    registrars: 1580,
    facilitySplit: "85% / 15%",
  },
  {
    id: 17,
    name: "Katsina",
    zone: "North West",
    target: 650000,
    registered: 494000,
    last30Days: "+30,100",
    registrars: 1050,
    facilitySplit: "78% / 22%",
  },
  {
    id: 18,
    name: "Kebbi",
    zone: "North West",
    target: 420000,
    registered: 151200,
    last30Days: "+8,900",
    registrars: 620,
    facilitySplit: "56% / 44%",
  },
  {
    id: 19,
    name: "Sokoto",
    zone: "North West",
    target: 480000,
    registered: 105600,
    last30Days: "+6,400",
    registrars: 580,
    facilitySplit: "54% / 46%",
  },
  {
    id: 20,
    name: "Zamfara",
    zone: "North West",
    target: 450000,
    registered: 99000,
    last30Days: "+5,800",
    registrars: 540,
    facilitySplit: "52% / 48%",
  },
  // South East
  {
    id: 21,
    name: "Abia",
    zone: "South East",
    target: 500000,
    registered: 385000,
    last30Days: "+24,500",
    registrars: 842,
    facilitySplit: "65% / 35%",
  },
  {
    id: 22,
    name: "Anambra",
    zone: "South East",
    target: 520000,
    registered: 400400,
    last30Days: "+25,800",
    registrars: 880,
    facilitySplit: "67% / 33%",
  },
  {
    id: 23,
    name: "Ebonyi",
    zone: "South East",
    target: 380000,
    registered: 102600,
    last30Days: "+6,200",
    registrars: 520,
    facilitySplit: "55% / 45%",
  },
  {
    id: 24,
    name: "Enugu",
    zone: "South East",
    target: 460000,
    registered: 345000,
    last30Days: "+22,100",
    registrars: 810,
    facilitySplit: "63% / 37%",
  },
  {
    id: 25,
    name: "Imo",
    zone: "South East",
    target: 500000,
    registered: 225000,
    last30Days: "+14,200",
    registrars: 720,
    facilitySplit: "60% / 40%",
  },
  // South South
  {
    id: 26,
    name: "Akwa Ibom",
    zone: "South South",
    target: 400000,
    registered: 88000,
    last30Days: "+5,400",
    registrars: 560,
    facilitySplit: "58% / 42%",
  },
  {
    id: 27,
    name: "Bayelsa",
    zone: "South South",
    target: 800000,
    registered: 656000,
    last30Days: "+42,100",
    registrars: 1205,
    facilitySplit: "82% / 18%",
  },
  {
    id: 28,
    name: "Cross River",
    zone: "South South",
    target: 800000,
    registered: 656000,
    last30Days: "+42,100",
    registrars: 1205,
    facilitySplit: "82% / 18%",
  },
  {
    id: 29,
    name: "Delta",
    zone: "South South",
    target: 600000,
    registered: 444000,
    last30Days: "+28,400",
    registrars: 980,
    facilitySplit: "74% / 26%",
  },
  {
    id: 30,
    name: "Edo",
    zone: "South South",
    target: 520000,
    registered: 374400,
    last30Days: "+24,200",
    registrars: 860,
    facilitySplit: "70% / 30%",
  },
  {
    id: 31,
    name: "Rivers",
    zone: "South South",
    target: 700000,
    registered: 595000,
    last30Days: "+38,600",
    registrars: 1150,
    facilitySplit: "80% / 20%",
  },
  // South West
  {
    id: 32,
    name: "Ekiti",
    zone: "South West",
    target: 380000,
    registered: 285000,
    last30Days: "+18,200",
    registrars: 780,
    facilitySplit: "68% / 32%",
  },
  {
    id: 33,
    name: "Lagos",
    zone: "South West",
    target: 1200000,
    registered: 1020000,
    last30Days: "+68,400",
    registrars: 2400,
    facilitySplit: "88% / 12%",
  },
  {
    id: 34,
    name: "Ogun",
    zone: "South West",
    target: 580000,
    registered: 452400,
    last30Days: "+29,800",
    registrars: 980,
    facilitySplit: "76% / 24%",
  },
  {
    id: 35,
    name: "Ondo",
    zone: "South West",
    target: 480000,
    registered: 307200,
    last30Days: "+20,100",
    registrars: 820,
    facilitySplit: "68% / 32%",
  },
  {
    id: 36,
    name: "Osun",
    zone: "South West",
    target: 440000,
    registered: 330000,
    last30Days: "+21,500",
    registrars: 840,
    facilitySplit: "70% / 30%",
  },
  {
    id: 37,
    name: "Oyo",
    zone: "South West",
    target: 620000,
    registered: 471200,
    last30Days: "+31,800",
    registrars: 1050,
    facilitySplit: "78% / 22%",
  },
];

const ZONES = [
  "All States",
  "North Central",
  "North East",
  "North West",
  "South East",
  "South South",
  "South West",
];
const SORT_OPTIONS = ["Alphabetical", "Achievement", "Zone"];

function getStatus(achievement) {
  if (achievement >= 70) return "HIGH PERFORMANCE";
  if (achievement >= 40) return "ON TRACK";
  return "ATTENTION REQUIRED";
}

const STATUS_CONFIG = {
  "HIGH PERFORMANCE": { color: "#006B3F", badgeBg: "#e8f5e9" },
  "ON TRACK": { color: "#d97706", badgeBg: "#fef3c7" },
  "ATTENTION REQUIRED": { color: "#dc2626", badgeBg: "#fee2e2" },
};

function StateEmblem({ name }) {
  const initials = name
    .replace(/[()]/g, "")
    .trim()
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("");
  return (
    <div
      className=" flex items-center justify-center flex-shrink-0 border border-gray-200"
      style={{
        width: "48px",
        height: "48px",
        background: "#F3F3F6",
        borderRadius: "8px",
      }}
    >
      <span className="text-xs font-bold" style={{ color: "#006B3F" }}>
        {initials}
      </span>
    </div>
  );
}

function StateCard({ state }) {
  const achievement = Math.round((state.registered / state.target) * 100);
  const status = getStatus(achievement);
  const { color, badgeBg } = STATUS_CONFIG[status];

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4">
      {/* Top row */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-2">
          <StateEmblem name={state.name} />
          <div>
            <p
              className="font-bold text-gray-900 mb-0 mt-0"
              style={{ fontSize: "20px" }}
            >
              {state.name}
            </p>
            <span
              className=" font-bold tracking-wider"
              style={{
                color,
                background: badgeBg,
                padding: "1px 7px",
                borderRadius: "4px",
                fontSize: "10px",
              }}
            >
              {status}
            </span>
          </div>
        </div>
        <div className="text-right">
          <p className="text-xs mb-1 mt-0" style={{ color: "#3E4A41" }}>
            Achievement
          </p>
          <p
            className="font-bold mb-0 mt-0"
            style={{ fontSize: "24px", color, lineHeight: 1 }}
          >
            {achievement}%
          </p>
        </div>
      </div>

      {/* Last 30 days + Registrars */}
      <div className="grid grid-cols-2 gap-2 mb-3">
        <div>
          <p
            className="mb-1 mt-0"
            style={{ color: "#3E4A41", fontSize: "11px" }}
          >
            LAST 30 DAYS
          </p>
          <p
            className="font-bold mb-0 mt-0"
            style={{ fontSize: "12px", color: "#1A1C1E" }}
          >
            {state.last30Days}
          </p>
        </div>
        <div>
          <p
            className="mb-1 mt-0"
            style={{ color: "#3E4A41", fontSize: "11px" }}
          >
            REGISTRARS
          </p>
          <p
            className="font-bold mb-0 mt-0"
            style={{ fontSize: "12px", color: "#1A1C1E" }}
          >
            {state.registrars.toLocaleString()} Active
          </p>
        </div>
      </div>

      {/* Facility / Comm split */}
      <div className="mb-3">
        <p className="mb-1 mt-0" style={{ color: "#3E4A41", fontSize: "11px" }}>
          FACILITY/COMM
        </p>
        <p
          className="font-bold mb-0 mt-0"
          style={{ fontSize: "12px", color: "#1A1C1E" }}
        >
          {state.facilitySplit}
        </p>
      </div>
      <div className="flex justify-between mb-2">
        <p className="text-xs text-gray-500 mb-0 mt-0">
          Registered: {state.registered.toLocaleString()}
        </p>
        <p className="text-xs text-gray-500 mb-0 mt-0">
          Target: {state.target.toLocaleString()}
        </p>
      </div>
      {/* Progress bar */}
      <div className="h-2 rounded-full bg-gray-100 ">
        <div
          className="h-2 rounded-full"
          style={{
            width: `${achievement}%`,
            background: color,
            transition: "width 0.4s ease",
          }}
        />
      </div>
    </div>
  );
}

export default function States({ initialZone = "All States" }) {
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("Alphabetical");
  const [zoneFilter, setZoneFilter] = useState(initialZone);

  // Sync when parent changes initialZone (e.g. "View States" clicked on a zone card)
  useEffect(() => {
    setZoneFilter(initialZone);
  }, [initialZone]);

  const filtered = useMemo(() => {
    let list = ALL_STATES.filter((s) => {
      const matchSearch = s.name.toLowerCase().includes(search.toLowerCase());
      const matchZone = zoneFilter === "All States" || s.zone === zoneFilter;
      return matchSearch && matchZone;
    });
    if (sort === "Alphabetical")
      list = [...list].sort((a, b) => a.name.localeCompare(b.name));
    if (sort === "Achievement")
      list = [...list].sort(
        (a, b) => b.registered / b.target - a.registered / a.target,
      );
    if (sort === "Zone")
      list = [...list].sort((a, b) => a.zone.localeCompare(b.zone));
    return list;
  }, [search, sort, zoneFilter]);

  return (
    <div>
      {/* Controls row */}
      <div className="flex flex-col md:flex-row items-stretch md:items-center gap-3 mb-5">
        {/* Search */}
        <div
          className="flex items-center gap-2 flex-1 bg-white border border-gray-200 rounded-lg px-4"
          style={{ height: "44px" }}
        >
          <FaSearch
            style={{ color: "#9ca3af", fontSize: "14px", flexShrink: 0 }}
          />
          <input
            type="text"
            placeholder="Search State..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="flex-1 text-sm text-gray-700 bg-transparent"
            style={{ border: "none", outline: "none", height: "100%" }}
          />
        </div>

        {/* Sort */}
        <div
          className="flex items-center gap-2 bg-white border border-gray-200 rounded-lg px-4 w-full md:w-auto"
          style={{ height: "44px", minWidth: "180px" }}
        >
          <span className="text-sm text-gray-500 whitespace-nowrap">
            Sort By:
          </span>
          <select
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="flex-1 text-sm font-medium text-gray-700 bg-transparent"
            style={{
              border: "none",
              outline: "none",
              cursor: "pointer",
              appearance: "none",
            }}
          >
            {SORT_OPTIONS.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </select>
          <FaChevronDown
            style={{
              color: "#6b7280",
              fontSize: "12px",
              pointerEvents: "none",
            }}
          />
        </div>

        {/* Zone filter */}
        <div
          className="flex items-center gap-2 bg-white border border-gray-200 rounded-lg px-4 w-full md:w-auto"
          style={{ height: "44px", minWidth: "180px" }}
        >
          <FaFilter
            style={{ color: "#6b7280", fontSize: "12px", flexShrink: 0 }}
          />
          <select
            value={zoneFilter}
            onChange={(e) => setZoneFilter(e.target.value)}
            className="flex-1 text-sm font-medium text-gray-700 bg-transparent"
            style={{
              border: "none",
              outline: "none",
              cursor: "pointer",
              appearance: "none",
            }}
          >
            {ZONES.map((z) => (
              <option key={z} value={z}>
                {z}
              </option>
            ))}
          </select>
          <FaChevronDown
            style={{
              color: "#6b7280",
              fontSize: "12px",
              pointerEvents: "none",
            }}
          />
        </div>
      </div>

      {/* Grid */}
      {filtered.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((state) => (
            <StateCard key={state.id} state={state} />
          ))}
        </div>
      ) : (
        <p className="text-gray-400 text-sm text-center py-12 mb-0">
          No states match your search.
        </p>
      )}
    </div>
  );
}
